import styled from 'styled-components';
import { Segment, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled(Segment)`
  display: flex;
  padding: 20px;
  flex-direction: column;
  border: 1px solid black;
  width: 500px;
  height: 150px;
  justify-content: center;
  &.ui.segment {
    margin-left: auto;
    margin-right: auto;
    margin-top: 125px;
  }
`;

export const Text = styled(TextLayoutComponent)`
  font-size: 18px;
  font-weight: 500;
  text-align: center;
`;
